import WbuTextInputMultilineMapper from '../.components/WbuTextInputMultiline/viewer/WbuTextInputMultiline.mapper';
import WbuThumbnailsMapper from '../.components/WbuThumbnails/viewer/WbuThumbnails.mapper';
import ControlTypesMapper from '../.components/ControlTypes/viewer/ControlTypes.mapper';
import McokSvgMapper from '../.components/McokSvg/viewer/McokSvg.mapper';
import SettingsPanelContainerMapper from '../.components/SettingsPanelContainer/viewer/SettingsPanelContainer.mapper';
import WbuAccordionSectionMapper from '../.components/WbuAccordionSection/viewer/WbuAccordionSection.mapper';
import WbuBackButtonMapper from '../.components/WbuBackButton/viewer/WbuBackButton.mapper';
import WbuButtonMapper from '../.components/WbuButton/viewer/WbuButton.mapper';
import WbuCheckboxGroupMapper from '../.components/WbuCheckboxGroup/viewer/WbuCheckboxGroup.mapper';
import WbuDrillInListItemMapper from '../.components/WbuDrillInListItem/viewer/WbuDrillInListItem.mapper';
import WbuDropdownMapper from '../.components/WbuDropdown/viewer/WbuDropdown.mapper';
import WbuEmptyStateMapper from '../.components/WbuEmptyState/viewer/WbuEmptyState.mapper';
import WbuHorizontalTabsMapper from '../.components/WbuHorizontalTabs/viewer/WbuHorizontalTabs.mapper';
import WbuLeftTextButtonMapper from '../.components/WbuLeftTextButton/viewer/WbuLeftTextButton.mapper';
import WbuNotificationBannerMapper from '../.components/WbuNotificationBanner/viewer/WbuNotificationBanner.mapper';
import WbuNumericInputMapper from '../.components/WbuNumericInput/viewer/WbuNumericInput.mapper';
import WbuRadioButtonGroupMapper from '../.components/WbuRadioButtonGroup/viewer/WbuRadioButtonGroup.mapper';
import WbuRichTextMapper from '../.components/WbuRichText/viewer/WbuRichText.mapper';
import WbuSectionDividerMapper from '../.components/WbuSectionDivider/viewer/WbuSectionDivider.mapper';
import WbuSliderMapper from '../.components/WbuSlider/viewer/WbuSlider.mapper';
import WbuTextInputMapper from '../.components/WbuTextInput/viewer/WbuTextInput.mapper';
import WbuToggleSwitchMapper from '../.components/WbuToggleSwitch/viewer/WbuToggleSwitch.mapper';
import WsrButtonMapper from '../.components/WsrButton/viewer/WsrButton.mapper';
import WutColorPickerMapper from '../.components/WutColorPicker/viewer/WutColorPicker.mapper';
import WutRadioButtonMapper from '../.components/WutRadioButton/viewer/WutRadioButton.mapper';
import WutTabbedContentMapper from '../.components/WutTabbedContent/viewer/WutTabbedContent.mapper';


const WbuTextInputMultiline = {
  mapper: WbuTextInputMultilineMapper
};

const WbuThumbnails = {
  mapper: WbuThumbnailsMapper
};

const ControlTypes = {
  mapper: ControlTypesMapper
};

const McokSvg = {
  mapper: McokSvgMapper
};

const SettingsPanelContainer = {
  mapper: SettingsPanelContainerMapper
};

const WbuAccordionSection = {
  mapper: WbuAccordionSectionMapper
};

const WbuBackButton = {
  mapper: WbuBackButtonMapper
};

const WbuButton = {
  mapper: WbuButtonMapper
};

const WbuCheckboxGroup = {
  mapper: WbuCheckboxGroupMapper
};

const WbuDrillInListItem = {
  mapper: WbuDrillInListItemMapper
};

const WbuDropdown = {
  mapper: WbuDropdownMapper
};

const WbuEmptyState = {
  mapper: WbuEmptyStateMapper
};

const WbuHorizontalTabs = {
  mapper: WbuHorizontalTabsMapper
};

const WbuLeftTextButton = {
  mapper: WbuLeftTextButtonMapper
};

const WbuNotificationBanner = {
  mapper: WbuNotificationBannerMapper
};

const WbuNumericInput = {
  mapper: WbuNumericInputMapper
};

const WbuRadioButtonGroup = {
  mapper: WbuRadioButtonGroupMapper
};

const WbuRichText = {
  mapper: WbuRichTextMapper
};

const WbuSectionDivider = {
  mapper: WbuSectionDividerMapper
};

const WbuSlider = {
  mapper: WbuSliderMapper
};

const WbuTextInput = {
  mapper: WbuTextInputMapper
};

const WbuToggleSwitch = {
  mapper: WbuToggleSwitchMapper
};

const WsrButton = {
  mapper: WsrButtonMapper
};

const WutColorPicker = {
  mapper: WutColorPickerMapper
};

const WutRadioButton = {
  mapper: WutRadioButtonMapper
};

const WutTabbedContent = {
  mapper: WutTabbedContentMapper
};


export const components = {
  ['WbuTextInputMultiline']: WbuTextInputMultiline,
  ['WbuThumbnails']: WbuThumbnails,
  ['ControlTypes']: ControlTypes,
  ['McokSvg']: McokSvg,
  ['SettingsPanelContainer']: SettingsPanelContainer,
  ['WbuAccordionSection']: WbuAccordionSection,
  ['WbuBackButton']: WbuBackButton,
  ['WbuButton']: WbuButton,
  ['WbuCheckboxGroup']: WbuCheckboxGroup,
  ['WbuDrillInListItem']: WbuDrillInListItem,
  ['WbuDropdown']: WbuDropdown,
  ['WbuEmptyState']: WbuEmptyState,
  ['WbuHorizontalTabs']: WbuHorizontalTabs,
  ['WbuLeftTextButton']: WbuLeftTextButton,
  ['WbuNotificationBanner']: WbuNotificationBanner,
  ['WbuNumericInput']: WbuNumericInput,
  ['WbuRadioButtonGroup']: WbuRadioButtonGroup,
  ['WbuRichText']: WbuRichText,
  ['WbuSectionDivider']: WbuSectionDivider,
  ['WbuSlider']: WbuSlider,
  ['WbuTextInput']: WbuTextInput,
  ['WbuToggleSwitch']: WbuToggleSwitch,
  ['WsrButton']: WsrButton,
  ['WutColorPicker']: WutColorPicker,
  ['WutRadioButton']: WutRadioButton,
  ['WutTabbedContent']: WutTabbedContent
};


// temporary export
export const version = "1.0.0"
